import { Style, InputType, DynamicUpdateAction, DynamicUpdateCondition } from 'common/questionnaires/types';
import helpText from 'common/questionnaires/helpText';
import moment from 'moment';
import format from 'date-fns/format';

const crscpQuestions = [
  {
    id: 'CRSCP.NAME.1',
    name: 'firstName',
    info: helpText.name,
    questionText: 'preQualifyingQuestionnaire.CRSCP.NAME.1.questionText',
    style: Style.Card,
    group: 'Name',
    answer: 'CUSTOMER-NAME',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'First Name', required: true }
      ]
    },
    errorMessage: 'Please provide a first name.'
  },
  {
    id: 'CRSCP.NAME.2',
    name: 'middleName',
    answer: 'CUSTOMER-NAME',
    questionText: 'preQualifyingQuestionnaire.CRSCP.NAME.2.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Middle Name', required: false }
      ]
    },
  },
  {
    id: 'CRSCP.NAME.3',
    name: 'lastName',
    questionText: 'preQualifyingQuestionnaire.CRSCP.NAME.3.questionText',
    style: Style.Embedded,
    answer: 'CUSTOMER-NAME',
    group: 'Name',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Last Name', required: true }
      ]
    },
    errorMessage: 'Please provide a last name.'

  },
  {
    id: 'CRSCP.NAME.4',
    name: 'title',
    questionText: 'preQualifyingQuestionnaire.CRSCP.NAME.4.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { value: 'Please Select', label: 'Please Select' },
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 'Mr', label: 'Mr' },
        { value: 'Mrs', label: 'Mrs' },
        { value: 'Ms', label: 'Ms' },
        { value: 'Miss', label: 'Miss' },
        { value: 'Other', label: 'Other' }
      ]
    }
  },
  {
    id: 'CRSCP.NAME.5',
    name: 'otherTitle',
    questionText: 'preQualifyingQuestionnaire.CRSCP.NAME.5.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Please type title', required: true }
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.NAME.4',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'Other',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    errorMessage: 'Please specify a Title.'
  },
  {
    id: 'CRSCP.ADDRESS.1',
    name: 'residenceAddressLine1',
    info: helpText.residenceAddress,
    questionText: 'preQualifyingQuestionnaire.W8BEN.ADDRESS.1.questionText',
    style: Style.Card,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Street Address', required: true }
      ]
    },
    errorMessage: 'Please provide a street address.'
  },
  {
    id: 'CRSCP.ADDRESS.2',
    name: 'residenceCitystateprovince',
    style: Style.Embedded,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'City/State/Province/Territory', required: true }
      ]
    },
    errorMessage: 'Please provide a city, state, province, or territory.'
  },
  {
    id: 'CRSCP.ADDRESS.3',
    name: 'residenceCountry',
    style: Style.Embedded,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.CountryDropdown,
      invalidSelection: 'Please Select Country',
      defaultSelection: 'Please Select Country'
    },
    errorMessage: 'Please provide a country.'
  },
  {
    id: 'CRSCP.ADDRESS.4',
    name: 'residencePostalcode',
    style: Style.Embedded,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Postal Code' }
      ]
    }
  },
  {
    id: 'CRSCP.MAILADDRESS.1',
    name: 'mailAddressLine1',
    info: helpText.mailingAddress,
    questionText: 'preQualifyingQuestionnaire.W8BEN.MAILADDRESS.1.questionText',
    style: Style.Card,
    group: 'Mailing Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Street Address', required: false }
      ]
    },
    partialFieldConstraint: ['CRSCP.MAILADDRESS.2', 'CRSCP.MAILADDRESS.3'],
    errorMessage: 'Please provide a street address.'
  },
  {
    id: 'CRSCP.MAILADDRESS.2',
    name: 'mailCityStateProvince',
    style: Style.Embedded,
    group: 'Mailing Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'City/State/Province/Territory', required: false }
      ]
    },
    partialFieldConstraint: ['CRSCP.MAILADDRESS.1', 'CRSCP.MAILADDRESS.3'],
    errorMessage: 'Please provide a city, state, province, or territory.'
  },
  {
    id: 'CRSCP.MAILADDRESS.3',
    name: 'mailCountry',
    style: Style.Embedded,
    group: 'Mailing Address',
    inputs: {
      type: InputType.CountryDropdown,
      defaultValue: { value: '0', label: 'Please Select Country' },
    },
    partialFieldConstraint: ['CRSCP.MAILADDRESS.1', 'CRSCP.MAILADDRESS.2'],
    errorMessage: 'Please provide a country.'
  },
  {
    id: 'CRSCP.MAILADDRESS.4',
    name: 'mailPostalCode',
    style: Style.Embedded,
    group: 'Mailing Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Postal Code', required: false }
      ]
    },
  },
  {
    id: 'CRSCP.TIN.1',
    name: 'countryOfTaxResidence1',
    style: Style.Card,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.1.questionText',
    inputs:
    {
      type: InputType.CountryDropdown,
      invalidSelection: 'Select a Country of Tax Residence',
      defaultSelection: 'Select a Country of Tax Residence',
      defaultValue: { value: 'Select a Country of Tax Residence', label: 'Select a Country of Tax Residence' },
    },
    errorMessage: 'Please select a country.'
  },
  {
    id: 'CRSCP.TIN.2',
    name: 'tin1',
    info: helpText.crs.tin,
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.2.questionText',
    group: 'Tax Identification Number (TIN)',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'TIN', required: false, validation: 'ftin' },
      ]
    },
    errorMessage: 'Please provide a TIN'
  },
  {
    id: 'CRSCP.TIN.3',
    name: 'tinreason1',
    style: Style.Embedded,
    group: 'Name',
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.6.questionText',
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select Reason',
      defaultValue: { value: 'Please Select Reason', label: 'Please Select Reason' },
      items: [
        { value: 'Please Select Reason', label: 'Please Select Reason' },
        { value: 'A', label: 'The country where the account holder is liable to pay tax does not issue TINs to its residents' },
        { value: 'B', label: 'The Account Holder is otherwise unable to obtain a TIN or equivalent number' },
        { value: 'C', label: 'No TIN is required.' },

      ]
    },
  },
  {
    id: 'CRSCP.TIN.4',
    name: 'reason1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.7.questionText',
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.3',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'B',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Residence 1 Reason', required: true },
      ]
    },
    errorMessage: 'Please provide a reason why you are unable to obtain a TIN where you have indicated you are otherwise unable to obtain a TIN or equivalent number.'
  },
  {
    id: 'CRSCP.TIN.8',
    name: 'showOtherTinFields1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.3.questionText',
    group: 'Tax Identification Number (TIN)',
    answer: 1,
    isAnswered: true,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    }
  },
  {
    id: 'CRSCP.TIN2.1',
    name: 'countryOfTaxResidence2',
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.4.questionText',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs:
    {
      type: InputType.CountryDropdown,
      invalidSelection: 'Select a Country of Tax Residence',
      defaultSelection: 'Select a Country of Tax Residence',
      defaultValue: { value: 'Select a Country of Tax Residence', label: 'Select a Country of Tax Residence' },
    },
    errorMessage: 'Please select a country.'
  },
  {
    id: 'CRSCP.TIN2.2',
    name: 'tin2',
    info: helpText.crs.controllingPersons,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.2.questionText',
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'TIN', required: false, validation: 'ftin' },
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSCP.TIN2.3',
    name: 'tinReason2',
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.6.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select Reason',
      defaultValue: { value: 'Please Select Reason', label: 'Please Select Reason' },

      items: [
        { value: 'Please Select Reason', label: 'Please Select Reason' },
        { value: 'A', label: 'The country where the account holder is liable to pay tax does not issue TINs to its residents' },
        { value: 'B', label: 'The Account Holder is otherwise unable to obtain a TIN or equivalent number' },
        { value: 'C', label: 'No TIN is required.' },
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSCP.TIN.5',
    name: 'reason2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.7.questionText',
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN2.3',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'B',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Residence 2 Reason', required: true },
      ]
    },
    errorMessage: 'Please provide a reason why you are unable to obtain a TIN where you have indicated you are otherwise unable to obtain a TIN or equivalent number.'
  },
  {
    id: 'CRSCP.TIN.9',
    name: 'showOtherTinFields2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.3.questionText',
    group: 'Tax Identification Number (TIN)',
    answer: 1,
    isAnswered: true,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSCP.TIN3.1',
    name: 'countryOfTaxResidence3',
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.5.questionText',
    inputs:
    {
      type: InputType.CountryDropdown,
      invalidSelection: 'Select a Country of Tax Residence',
      defaultSelection: 'Select a Country of Tax Residence',
      defaultValue: { value: 'Select a Country of Tax Residence', label: 'Select a Country of Tax Residence' },
    },
    errorMessage: 'Please select a country.',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSCP.TIN3.2',
    name: 'tin3',
    info: helpText.foreignTinControllingPersons,
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.2.questionText',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'TIN', required: false, validation: 'ftin' },
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSCP.TIN3.3',
    name: 'tinReason3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.6.questionText',
    group: 'Name',
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select Reason',
      defaultValue: { value: '0', label: 'Please Select Reason' },
      items: [
        { value: 'Please Select Reason', label: 'Please Select Reason' },
        { value: 'A', label: 'The country where the account holder is liable to pay tax does not issue TINs to its residents' },
        { value: 'B', label: 'The Account Holder is otherwise unable to obtain a TIN or equivalent number' },
        { value: 'C', label: 'No TIN is required.' },

      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSCP.TIN.6',
    name: 'reason3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.TIN.7.questionText',
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.TIN3.3',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'B',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Residence 3 Reason', required: true },
      ]
    },
    errorMessage: 'Please provide a reason why you are unable to obtain a TIN where you have indicated you are otherwise unable to obtain a TIN or equivalent number.'
  },
  {
    id: 'CRSCP.DOB.1',
    name: 'dob',
    style: Style.Card,
    questionText: 'preQualifyingQuestionnaire.CRSCP.DOB.1.questionText',
    info: helpText.dateOfBirth,
    group: 'Date and Place of Birth',
    inputs: {
      type: InputType.DateDropdown,
      maxDate: format(moment().subtract(1, 'days').toDate(), 'dd-MM-yyyy'),
      dateFormat: 'dd-MM-yyyy',
      fields: [
        { placeholder: 'Enter Date (DD-MM-YYYY)', required: true }
      ]
    },
    errorMessage: 'Please provide a Date of Birth.'
  },
  {
    id: 'CRSCP.DOB.2',
    name: 'countryOfBirth',
    questionText: 'preQualifyingQuestionnaire.CRSCP.DOB.2.questionText',
    style: Style.Embedded,
    group: 'Date and Place of Birth',
    inputs: {
      type: InputType.CountryDropdown,
      invalidSelection: 'Please Select Country',
      defaultSelection: 'Please Select Country'
    },
    errorMessage: 'Please provide a country of birth.'
  },
  {
    id: 'CRSCP.DOB.3',
    questionText: 'preQualifyingQuestionnaire.CRSCP.DOB.3.questionText',
    name: 'townCityOfBirth',
    style: Style.Embedded,
    group: 'Date and Place of Birth',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Town or City of Birth', required: false }
      ]
    },
  },
  {
    id: 'CRSCP.ENTITY.1',
    questionText: 'preQualifyingQuestionnaire.CRSCP.ENTITY.1.questionText',
    info: helpText.controllingPersons,
    name: 'entityName1',
    style: Style.Card,
    group: 'Entity Names',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Entity name 1', required: true }
      ]
    },
    errorMessage: 'Please provide at least one entity legal name.'
  },
  {
    id: 'CRSCP.ENTITY.2',
    name: 'showOtherLegalEntityField1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.ENTITY.2.questionText',
    group: 'Entity Names',
    answer: 1,
    isAnswered: true,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    }
  },
  {
    id: 'CRSCP.ENTITY.3',
    questionText: 'preQualifyingQuestionnaire.CRSCP.ENTITY.3.questionText',
    name: 'entityName2',
    style: Style.Embedded,
    group: 'Entity Names',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Entity name 2', required: true }
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.ENTITY.2',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    errorMessage: 'Please provide the second entity legal name.'
  },
  {
    id: 'CRSCP.ENTITY.4',
    name: 'showOtherLegalEntityField2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.ENTITY.2.questionText',
    group: 'Entity Names',
    answer: 1,
    isAnswered: true,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.ENTITY.2',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSCP.ENTITY.5',
    questionText: 'preQualifyingQuestionnaire.CRSCP.ENTITY.5.questionText',
    name: 'entityName3',
    style: Style.Embedded,
    group: 'Entity Names',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Entity name 3', required: true }
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.ENTITY.4',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    errorMessage: 'Please provide the third entity legal name.'
  },
  {
    id: 'CRSCP.CP.1',
    name: 'cpControl1',
    style: Style.Card,
    info: helpText.crscp.typeOfControl,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.1.questionText',
    group: 'Type of Controlling Person',
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 'A Legal Person', label: 'A Legal Person' },
        { value: 'A Trust', label: 'A Trust' },
        { value: 'A Legal Arrangement', label: 'A Legal Arrangement' },
      ]
    },
    errorMessage: 'Indicate what the Controlling Person has control over.'
  },
  {
    id: 'CRSCP.CP.2',
    name: 'cpNatureOfControl1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.2.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.1',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Legal Person',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Ownership' },
        { value: 2, label: 'Senior Management Position' },
        { value: 3, label: 'Other Means' },
      ]
    },
    errorMessage: 'Indicate the nature of control exercised by the Controlling Person.'
  },
  {
    id: 'CRSCP.CP.3',
    name: 'cpTrustStatus1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.3.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.1',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Trust',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Settlor' },
        { value: 2, label: 'Trustee' },
        { value: 3, label: 'Protector' },
        { value: 4, label: 'Beneficiary' },
        { value: 5, label: 'Other' },
      ]
    },
    errorMessage: 'Please provide the status of the Controlling Person in the trust.'
  },
  {
    id: 'CRSCP.CP.4',
    name: 'cpEntityStatus1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.4.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.1',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Legal Arrangement',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Settlor-Equivalent' },
        { value: 2, label: 'Trustee-Equivalent' },
        { value: 3, label: 'Protector-Equivalent' },
        { value: 4, label: 'Beneficiary-Equivalent' },
        { value: 5, label: 'Other-Equivalent' },
      ]
    },
    errorMessage: 'Please provide the status of the Controlling Person in the legal arrangement.'
  },
  {
    id: 'CRSCP.CP.5',
    name: 'cpControl2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.5.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.ENTITY.2',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 'A Legal Person', label: 'A Legal Person' },
        { value: 'A Trust', label: 'A Trust' },
        { value: 'A Legal Arrangement', label: 'A Legal Arrangement' },
      ]
    },
    errorMessage: 'Indicate what the Controlling Person has control over.'
  },
  {
    id: 'CRSCP.CP.6',
    name: 'cpNatureOfControl2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.6.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.5',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Legal Person',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Ownership' },
        { value: 2, label: 'Senior Management Position' },
        { value: 3, label: 'Other Means' },
      ]
    },
    errorMessage: 'Indicate the nature of control exercised by the Controlling Person.'
  },
  {
    id: 'CRSCP.CP.7',
    name: 'cpTrustStatus2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.7.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.5',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Trust',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Settlor' },
        { value: 2, label: 'Trustee' },
        { value: 3, label: 'Protector' },
        { value: 4, label: 'Beneficiary' },
        { value: 5, label: 'Other' },
      ]
    },
    errorMessage: 'Please provide the status of the Controlling Person in the trust.'
  },
  {
    id: 'CRSCP.CP.8',
    name: 'cpEntityStatus2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.8.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.5',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Legal Arrangement',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Settlor-Equivalent' },
        { value: 2, label: 'Trustee-Equivalent' },
        { value: 3, label: 'Protector-Equivalent' },
        { value: 4, label: 'Beneficiary-Equivalent' },
        { value: 5, label: 'Other-Equivalent' },
      ]
    },
    errorMessage: 'Please provide the status of the Controlling Person in the legal arrangement.'
  },
  {
    id: 'CRSCP.CP.9',
    name: 'cpControl3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.9.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.ENTITY.4',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 'A Legal Person', label: 'A Legal Person' },
        { value: 'A Trust', label: 'A Trust' },
        { value: 'A Legal Arrangement', label: 'A Legal Arrangement' },
      ]
    },
    errorMessage: 'Indicate what the Controlling Person has control over.'
  },
  {
    id: 'CRSCP.CP.10',
    name: 'cpNatureOfControl3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.10.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Legal Person',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Ownership' },
        { value: 2, label: 'Senior Management Position' },
        { value: 3, label: 'Other Means' },
      ]
    },
    errorMessage: 'Indicate the nature of control exercised by the Controlling Person.'
  },
  {
    id: 'CRSCP.CP.11',
    name: 'cpTrustStatus3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.11.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Trust',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Settlor' },
        { value: 2, label: 'Trustee' },
        { value: 3, label: 'Protector' },
        { value: 4, label: 'Beneficiary' },
        { value: 5, label: 'Other' },
      ]
    },
    errorMessage: 'Please provide the status of the Controlling Person in the trust.'
  },
  {
    id: 'CRSCP.CP.12',
    name: 'cpEntityStatus3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSCP.CP.12.questionText',
    group: 'Type of Controlling Person',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.CP.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'A Legal Arrangement',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select',
      defaultValue: { value: 0, label: 'Please Select' },
      invalidSelection: 'Please Select',
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 1, label: 'Settlor-Equivalent' },
        { value: 2, label: 'Trustee-Equivalent' },
        { value: 3, label: 'Protector-Equivalent' },
        { value: 4, label: 'Beneficiary-Equivalent' },
        { value: 5, label: 'Other-Equivalent' },
      ]
    },
    errorMessage: 'Please provide the status of the Controlling Person in the legal arrangement.'
  },
  {
    id: 'CRSCP.Signer.1',
    name: 'signerName',
    info: helpText.signerName,
    questionText: 'preQualifyingQuestionnaire.CRSCP.Signer.1.questionText',
    style: Style.Card,
    group: 'Signer Details',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Signer Name', required: true }
      ]
    },
    errorMessage: 'Required: Signer name is required.'
  },
  {
    id: 'CRSCP.Signer.2',
    name: 'capacityField',
    info: helpText.capacity,
    questionText: 'preQualifyingQuestionnaire.CRSCP.Signer.2.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    complexCapacityContraint: {
      signerNameId: 'CRSCP.Signer.1',
      givenNameId: ['CRSCP.NAME.1', 'CRSCP.NAME.2', 'CRSCP.NAME.3'],
      expectedValue: 'Signing on Own Behalf'
    },
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { value: 'Signing on Own Behalf', label: 'Signing on Own Behalf' },
      items: [
        { value: 'Signing on Own Behalf', label: 'Signing on Own Behalf' },
        { value: 'Conservator', label: 'Conservator' },
        { value: 'Custodian for Minor Child', label: 'Custodian for Minor Child' },
        { value: 'Father', label: 'Father' },
        { value: 'Guardian', label: 'Guardian' },
        { value: 'Mother', label: 'Mother' },
        { value: 'Power of Attorney', label: 'Power of Attorney' },
        { value: 'Attorney in Fact', label: 'Attorney in Fact' },
        { value: 'Authorized Signer', label: 'Authorized Signer' },
        { value: 'Other', label: 'Other' },
      ]
    },
    errorMessage: 'Capacity is required when name and signer name do not match.'
  },
  {
    id: 'CRSCP.Signer.3',
    name: 'capacityFieldOther',
    questionText: 'preQualifyingQuestionnaire.CRSCP.Signer.3.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    dynamicUpdate: {
      inputQuestionId: 'CRSCP.Signer.2',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'Other',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Capacity', required: true }
      ]
    },
    errorMessage: 'Please provide the capacity in which you are acting.'
  },
];

export default crscpQuestions;
